// This file has been partially auto generated. 
// Please don't make any changes to the lenses.
// Feel free to add or remove annotated properties from
// the generator data class. The corresponding lenses 
// will be removed or added on the next run of the 
// lens generator. See below for more details.
package org.solyton.solawi.bid.module.permissions.data.relations

import org.evoleq.optics.Lensify
import org.evoleq.optics.ReadOnly
import org.evoleq.optics.lens.Lens

/**
 * Generator class.
 * Feel free to add or remove annotated properties from
 * the class. Make sure that they are annotated with
 * - @ReadOnly
 * - @ReadWrite
 * If you want that a property-lens will be generated
 * on the next run of the lens generator.
 * If not, just omit the annotation or annotate it with @Ignore.
 */
@Lensify data class ContextRelation(
    @ReadOnly val contextId: String,
    @ReadOnly val relatedId: String
)

/**
 * Autogenerated ReadOnly Lens.
 * Read [ContextRelation.contextId]
 */
@ReadOnly val contextId: Lens<ContextRelation, String> by lazy{ Lens(
    get = {whole -> whole.contextId},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [ContextRelation.relatedId]
 */
@ReadOnly val relatedId: Lens<ContextRelation, String> by lazy{ Lens(
    get = {whole -> whole.relatedId},
    set = {{it}}
) }
